import { Button } from '@virtidev/toolbox';
import styled, { css } from 'styled-components';

export const MobileGoBigWrapper = styled.div`
  ${({ theme: { spacing, color } }) => css`
    position: fixed;
    padding: ${spacing.sm};
    text-align: center;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 1010;
    background-color: ${color.white};
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    gap: ${spacing.md};
  `}
`;

export const Message = styled.div`
  ${({ theme: { font, spacing } }) => css`
    ${font.note}
    display: flex;
    justify-content: center;
    align-items: center;
    gap: ${spacing.sm};
    text-align: left;
    padding: 0 ${spacing.sm};
  `}
`;

export const LandscapeWellDone = styled(Message)`
  @media screen and (orientation: portrait) {
    display: none;
  }
`;

export const PortraitOhNo = styled(Message)`
  @media screen and (orientation: landscape) {
    display: none;
  }
`;

export const MessagesWrapper = styled.div`
  ${({ theme: { spacing } }) => css`
    display: flex;
    gap: ${spacing.md};
    flex-direction: column;
    padding-bottom: ${spacing.sm};
  `}
`;

export const ContinueButton = styled(Button)`
  ${({ $isFullscreen, theme: { spacing } }) => css`
    @media screen and (orientation: portrait) {
      display: none;
    }
    ${!$isFullscreen &&
    css`
      display: none;
    `}
  `}
`;
